import React from "react";
import "./styles.css";

const ListeningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="svg-container-view-only" viewBox="0 0 24 24" fill="none">
    <path className="listening-bar-1" d="M4 10V13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path className="listening-bar-2" d="M8 6V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path className="listening-bar-3" d="M12 3V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path className="listening-bar-4" d="M16 8V15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path className="listening-bar-5" d="M20 5V18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default ListeningIcon;
